export const getOptionOnListById = (
  list: { id: number; descricao: string; linkertEmoji: number }[],
  id: number,
) => {
  const option = list.find(item => item.id === id);
  return option;
};
